import apiPath from '@/lib/apiPath';
import request from '@/lib/request';
import { chatStore } from '@/store/chatStore';
import { rootStore } from '@/store/rootStore';

export async function getPlatformType() {
  const store = rootStore();
  const res = await request.get(apiPath.config.getGlobalConfig);
  store.setPlatformType(res.platform_type);
}

export const getBasicMonitorInfo = () => {
  const store = chatStore();
  const rootStoreEx = rootStore();
  return {
    uid: rootStoreEx.currentCSInfo?.id,
    sessionid: store.currentChatRoomInfo?.sessionId,
    server_id: store.currentchatRoomInfo?.receiveId,
    im_status: store.imStatus,
    network_status: store.networkStatus === 'offline' ? 'none' : navigator?.connection?.effectiveType || 'unknown',
    client_status: document.visibilityState === 'visible' ? '前台' : '後台',
  };
};

export const reportMonitorInfo = (eventName: string, opts = {}) => {
  const monitorInfo = getBasicMonitorInfo();
  window.sense &&
    window.sense?.track(eventName, {
      ...monitorInfo,
      ...opts,
    });
};
